import React from 'react';
import { Surface } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import { truncate } from 'lodash';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import FontIcon from '@src/components/FontIcon';
import Touchable from '@src/components/Touchable';
import { Body1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';
import { Rank } from '@src/types';

type Props = {
  index: number;
  item?: Rank;
  size?: number;
};

const Container = styled(Surface)`
  justify-content: space-between;
  align-items: stretch;
  border-radius: ${({ theme }) => theme.roundness}px;
  padding-horizontal: ${padding}px;
  background: ${({ theme }) => theme.colors.background};
  overflow: hidden;
`;

const RankWrapper = styled.View`
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const Star = styled(FontIcon).attrs(({ theme }) => ({
  name: 'star',
  color: theme.colors.accent,
  size: 12,
}))``;

const Title = styled(Body1)`
  margin-vertical: 4px;
  height: 24px;
  align-self: center;
`;

const RankTitle = styled(Body1)`
  margin-top: 6px;
`;

const Component: React.FC<Props> = ({ item, size = 56 }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(() => {
    if (item) {
      // @ts-ignore
      navigation.push('Profile', { id: item.user.id });
    }
  }, [item, navigation]);

  if (!item) {
    return null;
  }

  const name = truncate(item.user.name ?? item.user.username, { length: 8 });

  return (
    <Touchable onPress={handlePress}>
      <Container>
        <Title>{name}</Title>
        <Avatar source={item.user.avatar} size={size} />
        <RankWrapper>
          <RankTitle>{item.score}</RankTitle>
          <Star />
        </RankWrapper>
      </Container>
    </Touchable>
  );
};

Component.displayName = 'RankAvatar';

export default React.memo(Component);
